import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@dabnet-kamu/libs/ui';
import { Observable } from 'rxjs';

// DKM-5139: servis BysBelge_BysBelgeSilsileGetir_Request (Bys host, /BYS/BysBelge/BysBelgeSilsileGetir).
// Yetki/gizlilik maskesi serviste: Gizli=true satırda belgeKod/tarih/sayı/birim gelmez.

export interface BysBelgeSilsileSatir {
  id: number;
  ustId: number;
  seviye: number;
  belgeKod?: number;
  tarih?: string;
  sayi?: string;
  kayitNo?: number;
  konu?: string;
  birim?: string;
  yon?: string;
  iliski?: string;
  durum?: string;
  gizlilik?: string;
  gizli: boolean;
  acilabilir: boolean;
  secili: boolean;
  digerUstSayisi: number;
}

export interface BysBelgeSilsileGetirResponse {
  result: boolean;
  errorMessage?: string;
  satirlar: BysBelgeSilsileSatir[];
  kesildi: boolean;
  belgeSayisi: number;
}

@Injectable({ providedIn: 'root' })
export class BelgeSilsileService {
  constructor(private http: HttpClient) {}

  getSilsile(belgeKod: number): Observable<BysBelgeSilsileGetirResponse> {
    return this.http.post<BysBelgeSilsileGetirResponse>(
      `${environment.bysService}api/BysBelge_BysBelgeSilsileGetir_Request`,
      { belgeKod }
    );
  }
}
